import { motion } from 'framer-motion'
import TextGenerateEffect from './TextGenerateEffect'
import Link from 'next/link'

const HeroBlock = () => {

    return (
        <div className="mx-auto px-4  flex flex-col items-center justify-between border-b border-red-100 bg-gray-950">
            <div className="flex flex-col pt-10 md:pt-40 relative overflow-hidden">
                <div className="pb-[60] md:pb-[100]">
                 <TextGenerateEffect
                            wordClassName="text-4xl lg:text-8xl"
                            words="МаркетСИЗ"
                            wordsCallbackClass={({ word }) =>
                                'bg-gradient-to-r from-[#FFFFFF] via-[#769ABC] to-[#FFFFFF] bg-clip-text text-transparent animate-gradient'
                            }
                        />
                    <TextGenerateEffect
                        wordClassName="text-2xl lg:text-4xl mt-2 relative z-10"
                        words=" интернет-магазин спецодежды"
                        wordsCallbackClass={({ word }) => {
                            if (word === 'интернет-магазин') {
                                return 'bg-gradient-to-r from-[#56BE99] via-[#227D5D] to-[#56BE99] bg-clip-text text-transparent animate-gradient'
                            }

                            if (word === 'спецодежды') {
                                return 'bg-gradient-to-r from-[#353082] to-[#6B66C0] bg-clip-text text-transparent animate-gradient'
                            }

                            return ''
                        }}
                    />
        {/* <div className="text-center mt-6  text-base md:text-xl text-muted text-white max-w-5xl mx-auto relative z-10 font-normal">Купить оптом спецодежду и средства индивидуальной защиты
                        для предприятий</div> */}
                    <motion.div
                        initial={{ opacity: 0, translateY: 40 }}
                        animate={{ opacity: 1, translateY: 0 }}
                        transition={{ duration: 0.3, delay: 0.5 }}
                        className="text-center mt-6  text-base md:text-xl text-muted text-white max-w-5xl mx-auto relative z-10 font-normal"
                    >
                        Купить оптом спецодежду и средства индивидуальной защиты
                        для предприятий
                        {/* Одеваем тех, кто создаёт, строит и защищает.
                        Качественная спецодежда, обувь и СИЗ напрямую от
                        производителей — без переплат, с гарантией и быстрой
                        доставкой по всей России. */}
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, translateY: 40 }}
                        animate={{ opacity: 1, translateY: 0 }}
                        transition={{ duration: 0.3, delay: 0.6 }}
                        className="flex items-center gap-4 justify-center mt-10 relative z-10"
                    >
                        <Link
                            href="/catalog"
                            className="inline-flex items-center justify-center bg-white text-primary font-semibold rounded-xl h-14 px-8 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 text-base"
                        >
                            Каталог
                        </Link>
                    </motion.div>

                </div>
            </div>
        </div>
    )
}

export default HeroBlock
